import { observer } from 'mobx-react';
import { currentUserStore } from '../../../../CurrentUserStore';
import { emptyFragment } from '../../../../EmptyFragment';
import GroupsStore from '../../../../GroupsStore';
import { findLink } from '../../../../LinkyLinky';
import { sortDirection } from '../../../../ListFilter';
import ParticipantsStore from '../../../../ParticipantsStore';
import SortableColumn from '../../../SortableColumn';

interface Props {
  store: ParticipantsStore | GroupsStore;
}

function OrganizationColumnHeader({ store }: Props) {
  return findLink('options', currentUserStore.links)
    .map(() => (
      <SortableColumn
        columnName={'Organization'}
        currentSortKey="organization"
        sortDirection={sortDirection(store.searchParameters)}
        onSortClicked={() => store.sorting('organization')}
        sortKey="organization"
        className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell"
      />
    ))
    .getOrElse(emptyFragment);
}

export default observer(OrganizationColumnHeader);
